import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useLang } from "../i18n/LanguageProvider";
import { FOOTER } from "../constants/testIds";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid={FOOTER.container} className="relative border-t border-[var(--bw-border)] mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo size={48} />
          <p className="text-muted mt-6 max-w-md text-sm leading-relaxed">
            {t("footer.tagline")}
          </p>
          <div className="mt-6 text-[11px] tracking-[0.28em] uppercase text-muted">
            {t("footer.uenLine")}
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-5">{t("footer.office")}</div>
          <address className="not-italic text-sm text-white/85 leading-relaxed">
            111 North Bridge Road<br />
            #15-02, Peninsula Plaza<br />
            Singapore 179098
          </address>
          <div className="mt-5 text-sm text-muted">
            <div>{t("footer.byAppointment")}</div>
            <a href="mailto:office@bonworldsingapore.com" className="text-gold hover:underline">office@bonworldsingapore.com</a>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow mb-5">{t("footer.navigate")}</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-gold">{t("nav.about")}</Link></li>
            <li><Link to="/philosophy" className="hover:text-gold">{t("nav.philosophy")}</Link></li>
            <li><Link to="/services" className="hover:text-gold">{t("nav.services")}</Link></li>
            <li><Link to="/team" className="hover:text-gold">{t("nav.team")}</Link></li>
            <li><Link to="/insights" className="hover:text-gold">{t("nav.insights")}</Link></li>
            <li><Link to="/contact" className="hover:text-gold">{t("nav.contact")}</Link></li>
            <li><Link to="/portal" className="hover:text-gold">{t("nav.portal")}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow mb-5">{t("footer.legal")}</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/imprint" data-testid={FOOTER.imprint} className="hover:text-gold">{t("page.imprint.title")}</Link></li>
            <li><Link to="/privacy" data-testid={FOOTER.privacy} className="hover:text-gold">{t("page.privacy.title")}</Link></li>
            <li><Link to="/cookies" data-testid={FOOTER.cookies} className="hover:text-gold">{t("page.cookies.title")}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[var(--bw-border)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-muted">
          <div>© {year} Bonworld Family Office Pte. Ltd. {t("footer.rights")}</div>
          <div className="tracking-[0.28em] uppercase text-[10px]">{t("footer.motto")}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
